"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildTreesCommand = void 0;
class BuildTreesCommand {
    constructor(endpoint, apiKey, input) {
        this.endpoint = endpoint;
        this.apiKey = apiKey;
        this.input = input;
    }
    execute() {
        return __awaiter(this, void 0, void 0, function* () {
            this.validate();
            const response = yield fetch(`${this.endpoint}/api/v1/tree/build-all`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.apiKey,
                },
                body: JSON.stringify(this.input),
            });
            if (!response.ok) {
                throw new Error(`Failed to build route trees: ${response.status} ${response.statusText}`);
            }
        });
    }
    validate() {
        if (!this.input.app && !this.input.entryId) {
            throw new Error("Either app or entryId must be set to build trees");
        }
    }
}
exports.BuildTreesCommand = BuildTreesCommand;
